"use client";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import React from 'react'




export const MyToast = () => {
  return (
    <ToastContainer></ToastContainer>
  )
}
